



















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
import _ from "lodash";

import Detail from "./reconciliationdetail.vue";

@Component({
  components: {
    Detail
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "finance/getReconciliations";

  detailModalVisible = false;

  oldData!: any;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "头像",
      scopedSlots: { customRender: "avatar" }
    },
    {
      title: "用户名称",
      scopedSlots: { customRender: "username" }
    },
    {
      title: "账面平台余额",
      scopedSlots: { customRender: "user_balance_total" }
    },
    {
      title: "账面场馆余额",
      scopedSlots: { customRender: "stadium_balance_total" }
    },
    {
      title: "追账平台余额",
      scopedSlots: { customRender: "user_balance_total_check" }
    },
    {
      title: "追账场馆余额",
      scopedSlots: { customRender: "stadium_balance_total_check" }
    },
    { title: "对账时间", dataIndex: "check_time" },
    { title: "对账结果", scopedSlots: { customRender: "result" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }

  showDetailModal(record: any) {
    this.oldData = record;
    this.detailModalVisible = true;
  }

  hideDetailModal() {
    this.detailModalVisible = false;
  }

  checkAllUser() {
    this.$confirm({
      title: "确认信息",
      content: "你确定要操作吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("finance/checkAllUser", {});
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  checkByUser(userId: number) {
    // console.log(userId)
    this.$confirm({
      title: "确认信息",
      content: "你确定要操作吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("finance/checkByUser", {
          user_id: userId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }
}
